import { IChartContainer } from "../models/base/chart-container.interface";
import { LimitAlertModel } from "../models/limit-alert/limit-alert.model";
import { IComponent } from "./component.interface";
import { LimitAlertPlotLineComponent } from "./limit-alert-plot-line.component";

export class DrawLimitAlertsComponent implements IComponent {
    public id = '';

    private base: IChartContainer;;
    private limitAlerts: Array<LimitAlertModel> = [];
    private limitAlertPlotLines: Array<LimitAlertPlotLineComponent> = [];
    private isRemovingForSwitchingSymbol = false;

    constructor(base: IChartContainer) {
        this.base = base;
        this.subscribeDrawLimitAlerts();
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        for (let i = 0; i < this.limitAlertPlotLines.length; i++) {
            this.limitAlertPlotLines[i].remove();
            delete this.limitAlertPlotLines[i];
        }

        this.limitAlerts = [];
        this.limitAlertPlotLines = [];

        this.isRemovingForSwitchingSymbol = false;
    }

    private drawLimitAlertsTimer: any;
    private subscribeDrawLimitAlerts() {
        this.base.chartService.subscribePriceAlertsData((limitAlerts: Array<LimitAlertModel>) => {
            if (this.isRemovingForSwitchingSymbol) {
                return;
            }

            clearTimeout(this.drawLimitAlertsTimer);
            this.drawLimitAlertsTimer = setTimeout(() => {
                // if (this.limitAlerts?.length) {return;}
                const anyPlotLineMoving = this.limitAlertPlotLines.some((x: LimitAlertPlotLineComponent) => x.moveMode || x.selected);
                if (anyPlotLineMoving) {
                    return;
                }

                this.limitAlerts = limitAlerts;
                this.removeLimitAlertLines();
                this.createLimitAlertLines();
            }, 520);
        });
    }

    private removeLimitAlertLines() {
        const plotLinesToRemove: Array<number> = [];
        for (let i = 0; i < this.limitAlertPlotLines.length; i++) {
            if (this.limitAlertPlotLines[i].updatedPrice == null || !this.limitAlerts.some((x: LimitAlertModel) => x.id == this.limitAlertPlotLines[i].id)) {
                plotLinesToRemove.push(i);
                this.limitAlertPlotLines[i].remove();
                delete this.limitAlertPlotLines[i];
            }
        }

        if (plotLinesToRemove.length) {
            for (const index of plotLinesToRemove) {
                this.limitAlertPlotLines.splice(index);
            }
        }
    }

    private createLimitAlertLines() {
        for (const limitAlert of this.limitAlerts) {
            const id = limitAlert.id;
            const existPlotLine = this.limitAlertPlotLines.find((x: LimitAlertPlotLineComponent) => x.id == id);
            if (existPlotLine && existPlotLine.updatedPrice != null && existPlotLine.updatedPrice.toFixed(2) == limitAlert.price.toFixed(2)) {
                existPlotLine.updatedPrice = null;
            } else {
                this.limitAlertPlotLines.push(new LimitAlertPlotLineComponent(this.base, limitAlert));
            }
        }
    }
}